// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import BootstrapValidationController from "./bootstrap_validation_controller"
application.register("bootstrap-validation", BootstrapValidationController)

import CompanyDocumentEditorController from "./company_document_editor_controller"
application.register("company-document-editor", CompanyDocumentEditorController)

import CompanyDocumentFormController from "./company_document_form_controller"
application.register("company-document-form", CompanyDocumentFormController)

import CompanyDocumentListController from "./company_document_list_controller"
application.register("company-document-list", CompanyDocumentListController)

import DocumentSummaryController from "./document_summary_controller"
application.register("document-summary", DocumentSummaryController)

import DummyGaugeReadingController from "./dummy_gauge_reading_controller"
application.register("dummy-gauge-reading", DummyGaugeReadingController)

import GaugeCaptureController from "./gauge_capture_controller"
application.register("gauge-capture", GaugeCaptureController)

import GaugePhotoModalController from "./gauge_photo_modal_controller"
application.register("gauge-photo-modal", GaugePhotoModalController)

import ModelPickerController from "./model_picker_controller"
application.register("model-picker", ModelPickerController)

import ProjectHeaderController from "./project_header_controller"
application.register("project-header", ProjectHeaderController)

import ProjectSearchDockController from "./project_search_dock_controller"
application.register("project-search-dock", ProjectSearchDockController)

import SopSourceNavigationController from "./sop_source_navigation_controller"
application.register("sop-source-navigation", SopSourceNavigationController)

import TabulatorController from "./tabulator_controller"
application.register("tabulator", TabulatorController)

import ViewportLockController from "./viewport_lock_controller"
application.register("viewport-lock", ViewportLockController)
